import axios from 'axios';
import { getExpressAPIHost } from '../../utils';

const uploadMonthlyPayDetails = async (formData, year, month, type) => {
    try {
        const response = await axios.post(`${getExpressAPIHost()}/monthly-pay-details/upload-pay-details/${year}/${month}/${type}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        throw new Error('Unable to upload file. Please contact support.');
    }
};
export default uploadMonthlyPayDetails;
